import { BannerTileComponent } from '@/components/banner/banner-tile';
import { BannerCampaign } from '@cinemark/content-api-client';
import { clsx } from 'clsx';
import { BannerComponent } from './banner';

type BannerType = 'banners' | 'bannerTiles';

type BannerCampaignSectionProps = {
  bannerCampaign?: BannerCampaign | null;
  bannerType: BannerType;
  className?: string;
  dataLinkCategory: string;
  dataTest?: string;
  imageAspectClassName?: string;
  maxBannersOrTiles?: number;
};

export const BannerCampaignSection = ({
  bannerCampaign,
  bannerType,
  className,
  dataLinkCategory,
  dataTest,
  imageAspectClassName,
  maxBannersOrTiles,
}: Readonly<BannerCampaignSectionProps>): React.JSX.Element | null => {
  const bannerTiles = maxBannersOrTiles ? bannerCampaign?.bannerTiles?.slice(0, maxBannersOrTiles) : bannerCampaign?.bannerTiles;
  const banners = maxBannersOrTiles ? bannerCampaign?.banners?.slice(0, maxBannersOrTiles) : bannerCampaign?.banners;

  if (bannerType === 'banners' && !banners?.length) {
    return null;
  }

  if (bannerType === 'bannerTiles' && !bannerTiles?.length) {
    return null;
  }

  return (
    <div className={clsx('w-full flex flex-col gap-ms', className)}
      data-test={dataTest}
    >
      {bannerType === 'banners' && banners?.map(banner =>
        <BannerComponent key={banner.id}
          banner={banner}
          dataLinkCategory={dataLinkCategory}
          imageClassName={imageAspectClassName}
        />
      )}

      {bannerType === 'bannerTiles' && bannerTiles?.map(bannerTile =>
        <BannerTileComponent key={bannerTile.id}
          bannerTile={bannerTile}
          dataLinkCategory={dataLinkCategory}
          imageAspectClassName={imageAspectClassName}
        />
      )}
    </div>
  );
};
